export default {"src":"/_next/static/media/TOASTER_CLOSE.9dcafdbd.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};